import { Injectable } from "@angular/core";
import { AuthProvider } from "../auth/auth";
import { AppConfig } from "../../config/app.config";
import { Category } from "../../models/category";
import { DataProvider } from "../data/data";

const ROUTE = '/api/banners/';

@Injectable()
export class BannerProviderMock {

    constructor() {
    }

    async getCategories(): Promise<Array<Category>> {
        var x = new Array<Category>();
        for (var index = 0; index < 10; index++) {
            var c = new Category();
            c.id = index;
            c.name = `Category ${index}`;
            x.push(c);
        }
        return x;
    }

    async getCategory(id: number): Promise<Category>{
        var c = new Category();
        c.id = id;
        c.name = `Category ${id}`;
        return c;
    }
}


// WEBPACK FOOTER //
// ./src/providers/banner/banner-mock.ts